document.addEventListener('alpine:init', () => {
  Alpine.data('bundle', (data) => ({
    discountFormula: data.discountFormula,
    selectedBundles: [],
    mainProductPrice: '',
    bundles: [],
    addToCartLoading: false,
    added: false,
    totalPrice() {
      let totalOld = this.mainProductPrice;
      let totalNew =  this.mainProductPrice;
      for (let index = 0; index < this.selectedBundles.length; index++) {
        const product = this.selectedBundles[index];
        const findProduct = this.bundles.find(el => Number(el.index) === Number(product))
        totalOld += findProduct.priceOld
        totalNew += findProduct.priceNew
      }
      return {
        old: totalOld.toFixed(2),
        new: totalNew.toFixed(2),
        discount: (totalOld - totalNew).toFixed(2)
      }
    },
    priceFilter(price) {
      if (!price) { return null }
      return price.toFixed(2)
    },
    setVariant(data) {
      const index = this.bundles.findIndex(el => el.index === data.index)
      this.bundles[index].id = data.data.id,
      this.bundles[index].priceOld = data.data.priceIncl,
      this.bundles[index].priceNew = data.data.priceIncl * this.discountFormula
      
      const findSelectedBundle = this.selectedBundles.find(el => el === data.index)
      if (!findSelectedBundle) {
        this.selectedBundles.push(data.index)
      }
     
    },
    getProduct(index) {
      return this.bundles.find(el => el.index === index)
    },
    async addToCart () {
      if (this.selectedBundles.length > 0) {
        this.addToCartLoading = true;
        await this.$store.main.addToCart([
          {
            variant_id: data.currentVariantID,
            quantity: 1
          },
          ...this.selectedBundles.map(variant => {
          const findProduct = this.bundles.find(el => Number(el.index) === Number(variant))
          return {
            variant_id: findProduct.id,
            quantity: 1
          }
        })], false, data.bundleParent)
        this.addToCartLoading = false;
        this.added = true;
        setTimeout(() => {
          this.added = false;
        }, 3000);
      }
    },
  }))
})